// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__rlpvW","big":"Tag_big__fJtwS"};